"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getIcon = getIcon;
exports.buildIcon = buildIcon;

var _react = _interopRequireDefault(require("react"));

var _constants = require("../constants");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getIcon(iconData) {
  var source = iconData.source;
  return _constants.API_TO_ICON_MAP[source] || _constants.API_TO_ICON_MAP.fa;
}

function buildIcon(iconData, index) {
  var IconComponent = getIcon(iconData);
  return _react.default.createElement(IconComponent, iconData);
}